import React, { useEffect, useMemo, useState } from "react";
import CustomChip from "views/pages/manage/common/customChip/CustomChip.jsx";
import { RiCheckFill } from "react-icons/ri";
// import { ReactComponent as ChevronDownIcon } from "assets/img/svg/downarrow.svg";
import { FaChevronDown } from "react-icons/fa6";
import { Card, MenuItem } from "@mui/material";
import APopover from "../../common/a-popover";

const MIN_INITIAL_RENDER_COUNT = 2;
const ApplicationIdChip = ({
  applicationId,
  checked,
  onClick,
  isLinkChip = false,
  details = {},
}) => {
  return (
    <>
      <CustomChip
        className={`col-applicationId-chip ${checked ? "active" : ""} ${
          isLinkChip ? "link-chip" : ""
        } ${
          details?.supplId?.length
            ? "d-flex align-item-center justify-content-between"
            : "text-center"
        }`}
        onClick={() => onClick(applicationId)}
      >
        <div>
          <span>{applicationId}</span>
          {checked && <RiCheckFill className="ml-2" color="#FFF" size={16} />}
        </div>

        {details?.supplId?.length ? (
          <APopover
            buttonComponent={(onClick, styles) => (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  onClick(e);
                }}
              >
                <FaChevronDown />
              </span>
            )}
            menuComponent={(closeForm) => (
              <>
                <Card
                  className="mb-0 regular-body label-color"
                  style={{ borderRadius: "12px" }}
                >
                  {details.supplId.map((id) => (
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        onClick(id.applicationId, applicationId);
                        closeForm();
                      }}
                      key={id.applicationId}
                    >
                      {id.applicationId}
                    </MenuItem>
                  ))}
                </Card>
              </>
            )}
            transformOriginVertical="center"
            transformOriginHorizontal="left"
          />
        ) : (
          <></>
        )}
      </CustomChip>
    </>
  );
};

const ApplicationIdList = ({
  studentApplicationDetails,
  currIndex,
  setCurrIndex,
  onApplicationChange = () => {},
}) => {
  const [showAll, setShowAll] = useState(false);

  const applicationIds = useMemo(() => {
    let normalIds = [],
      supplementaryIds = [];

    studentApplicationDetails.forEach((obj, index) => {
      if (obj.applicationId.includes("-"))
        supplementaryIds.push({ ...obj, index });
      else normalIds.push({ ...obj, index, supplId: [] });
    });

    if (supplementaryIds.length) {
      for (let i = 0; i < normalIds.length; i++) {
        for (let j = 0; j < supplementaryIds.length; j++) {
          if (
            supplementaryIds[j].applicationId.includes(
              normalIds[i].applicationId
            )
          )
            normalIds[i]["supplId"].push(supplementaryIds[j]);
        }
      }
    }

    return normalIds;
  }, [studentApplicationDetails]);

  useEffect(() => {
    if (applicationIds.length) setCurrIndex(applicationIds[0].index);
  }, [applicationIds]);

  return studentApplicationDetails?.length > 1 ? (
    <div className="applicationId-selector-container mb-4">
      <div className="text-center semi-bold mb-2">Application IDs</div>
      <div className="applicationId-selector">
        {(showAll || applicationIds?.length <= MIN_INITIAL_RENDER_COUNT + 1
          ? applicationIds
          : applicationIds?.slice(0, MIN_INITIAL_RENDER_COUNT)
        )?.map((item) => (
          <ApplicationIdChip
            key={JSON.stringify(item)}
            applicationId={item?.applicationId}
            details={item}
            checked={currIndex === item.index}
            onClick={(id, parentId = "") => onApplicationChange(id, parentId)}
          />
        ))}

        {!showAll && applicationIds?.length > MIN_INITIAL_RENDER_COUNT + 1 && (
          <ApplicationIdChip
            key={JSON.stringify("count")}
            applicationId={`+${
              applicationIds?.length - MIN_INITIAL_RENDER_COUNT
            } more`}
            checked={false}
            onClick={() => setShowAll(true)}
            isLinkChip
          />
        )}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default ApplicationIdList;
